import loadable from '@loadable/component';

export const EmbedSearchWidgetSearchVolopsPageLoadable = loadable(
  () => import('./EmbedSearchWidgetSearchVolopsPage'),
  { resolveComponent: (module) => module.EmbedSearchWidgetSearchVolopsPage },
);
